// extracted by mini-css-extract-plugin
export default {"imageContainer":"ComplexProject_imageContainer__Oh75w","contentContainer":"ComplexProject_contentContainer__2noRP","list":"ComplexProject_list__8KeNV"};